import { render } from "./DashboardDetailDrawer.component.vue?vue&type=template&id=37686a2b"
import script from "./DashboardDetailDrawer.component.vue?vue&type=script&lang=js"
export * from "./DashboardDetailDrawer.component.vue?vue&type=script&lang=js"

import "./DashboardDetailDrawer.component.vue?vue&type=style&index=0&id=37686a2b&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QScrollArea,QToolbar,QBtn,QToolbarTitle});
